module.exports = "/virtual-football-league/img/jerseys/Orange.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/jerseys/Orange.png
// module id = 2241
// module chunks = 4